module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, undefined) {
	'use strict';

	var _ = {
		ERROR_SERVERCONNECT: 'server error',

		MIN_TIMEOUT_SOCKET_RECONNECT: 1000,
		MAX_TIMEOUT_SOCKET_RECONNECT: 30000,

		INBOX_EVENT_PREFIX: 'inboxSocketEvent',

		attemptsCount: 0,
		
		socketReady: function () {
			this._isReady = true;
			this.dispatchEvent('socketReady');
		},

		sendApi: function(api, params) {
			var message = {
				wom: '@' + api.getId(),
				params: params
			};

			this.socket.send(message);
		},

		getTimeout: function () {
			var result = this.MIN_TIMEOUT_SOCKET_RECONNECT * Math.pow(Math.E, this.attemptsCount);

			if (result < this.MAX_TIMEOUT_SOCKET_RECONNECT) {
				this.attemptsCount++;

				return result;
			}


			return this.MAX_TIMEOUT_SOCKET_RECONNECT;
		}
	};

	fox.registerWidget('Socket', {
		configure: function(options) {
			var l = document.location;

			this.registerOptions('', {
				'address': l.protocol + '//' + l.hostname + ':' + l.port,
				'path': '/ws'
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this.waitPool = [];
			this.inboxPool = [];
			this._isReady = false;
			if (navigator.userAgent === 'FoxPhantom') {
				return false;
			}

			if (window.io) {
				this.socketInited();
			} else {
				var script = document.createElement('script');
				script.onload = fox.bind(this.socketInited, this);
				script.src = this.getOption('address') + (this.getOption('path') || '') + '/socket.io/socket.io.js';
				document.body.appendChild(script);
			}

			Object.defineProperty(this._wom.getRoot(), 'Socket', {
				get: function() {return this._wom.getRoot().rwom1('#socket');}.bind(this)
			});
		},

		socketConnect: function () {
			if (!this.socket) {
				this.socket = window.io.connect(this.getOption('address'), {
					path: (this.getOption('path') || '') + '/socket.io',
					enablesXDR: true,
					reconnection: true,
					reconnectionDelay: _.getTimeout(),
					transports: ['websocket']
				});
			} else {
				setTimeout(fox.bind(function () {
					this.socket.connect();
				}, this), _.getTimeout());
			}
		},

		socketInited: function() {
			if (typeof window.io === 'undefined') {
				return;
			}

			this.socketConnect();

			this.socket.on('message', fox.bind(this.inbox, this));

			this.socket.on('connect', fox.bind(function() {
				_.socketReady.call(this);
				fox.each(this.waitPool, function(request) {
					_.sendApi.apply(this, request);
				}, this);
			}, this));

			this.socket.on('reconnecting',fox.bind(function() {
				this._isReady = false;
			}, this));

			this.socket.on('connect_error',fox.bind(function(e) {
				this._isReady = false;
				this.dispatchEvent('socketConnectError');

				if (e.message === _.ERROR_SERVERCONNECT) {
					this.socket.disconnect();
				} else {
					this.socketConnect();
				}
			}, this));

			this.socket.on('disconnect',fox.bind(function(e) {
				console.log('Socket disconnected:', e);
				this._isReady = false;
				this.dispatchEvent('socketDisconnected');
				this.socketConnect();
			}, this));
		},

		isReady: function() {
			return this._isReady;
		},

		sendApiRequest: function(api, params) {
			if (this.socket) {
				return _.sendApi.call(this, api, params);
			}

			this.waitPool.push([api, params]);
		},

		inbox: function(message) {
			this.inboxPool.push(message);

			try {
				message = JSON.parse(message);
				message.response = message.response ? JSON.parse(message.response) : {};
			} catch (e) {
				return;
			}

			var transit = (message || {}).transit || {};

			if (transit.wom) {
				var w = fox.wom.selectFirst(transit.wom);
				if (!w) {
					return;
				}
				w.dispatchResponseEvent({answer: message.response});
			} else if (transit.topic) {
				this.dispatchEvent([_.INBOX_EVENT_PREFIX, fox.ucfirst(transit.topic)].join(''), {
					answer: fox.isEmpty(message.response) ?
						message.message :
						message.response
				});
			}
		},

		send: function(message) {
			this.socket.send(message);
		}
	}, 'Controller');

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/socket.js
// module id = 224
// module chunks = 0